import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { hero, LANDING_LINKS } from "./landingContent";
import { prefetchVacationPackagesDiscoveryHome } from "../../../utils/prefetchVacationPackagesDiscoveryHome";
import { LandingHeroMockupCollage } from "./LandingAbstractMockups";

export default function LandingHero() {
  const { t } = useTranslation();

  return (
    <section className="hr-landing-hero" aria-labelledby="hr-landing-hero-title">
      <div className="hr-landing-hero__bg" aria-hidden />
      <div className="home-page__container hr-landing-hero__inner">
        <div className="hr-landing-hero__copy">
          <p className="hr-landing-hero__eyebrow">{hero.eyebrow}</p>
          <h1 id="hr-landing-hero-title" className="hr-landing-hero__title">
            {hero.title}
          </h1>
          <p className="hr-landing-hero__subtitle">{hero.subtitle}</p>
          <div className="hr-landing-hero__actions">
            <Link to={LANDING_LINKS.registerAgent} className="hr-landing-btn hr-landing-btn--primary">
              {t("navbar.joinasagent") || hero.primaryCta}
            </Link>
            <Link to={LANDING_LINKS.login} className="hr-landing-btn hr-landing-btn--ghost">
              {hero.secondaryCta}
            </Link>
          </div>
          <div className="hr-landing-hero__links">
            <Link
              to={LANDING_LINKS.vacationPackages}
              className="hr-landing-text-link"
              onMouseEnter={prefetchVacationPackagesDiscoveryHome}
              onFocus={prefetchVacationPackagesDiscoveryHome}
            >
              {hero.tertiaryCta}
            </Link>
            <span className="hr-landing-hero__dot" aria-hidden />
            <Link to={LANDING_LINKS.flightsSearch} className="hr-landing-text-link">
              {hero.tertiaryCtaSecondary}
            </Link>
          </div>
        </div>
        <div className="hr-landing-hero__visual">
          <LandingHeroMockupCollage />
        </div>
      </div>
    </section>
  );
}
